import React, { useEffect, useState } from "react";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import { scroller, animateScroll as scroll } from "react-scroll";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import "./Navbar.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const isHome = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (location.hash) {
      const section = location.hash.replace("#", "");
      const el = document.getElementById(section);
      if (el) {
        setTimeout(() => {
          scroller.scrollTo(section, {
            duration: 600,
            smooth: "easeInOutQuart",
            offset: -70,
          });
        }, 400);
      }
    }
  }, [location]);

  const handleScrollTo = (section) => {
    const el = document.getElementById(section);
    if (el) {
      scroller.scrollTo(section, {
        duration: 600,
        smooth: "easeInOutQuart",
        offset: -70,
      });
    } else {
      navigate(`/#${section}`);
    }

    const navbarCollapse = document.querySelector(".navbar-collapse");
    if (navbarCollapse?.classList.contains("show")) {
      navbarCollapse.classList.remove("show");
    }
  };

  const handleGoHome = (e) => {
    e.preventDefault();
    if (!isHome) {
      navigate("/");
      setTimeout(() => scroll.scrollToTop({ duration: 600, smooth: true }), 400);
    } else {
      scroll.scrollToTop({ duration: 600, smooth: true });
    }

    const navbarCollapse = document.querySelector(".navbar-collapse");
    if (navbarCollapse?.classList.contains("show")) {
      navbarCollapse.classList.remove("show");
    }
  };

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);

    const navbarCollapse = document.querySelector(".navbar-collapse");
    if (navbarCollapse?.classList.contains("show")) {
      navbarCollapse.classList.remove("show");
    }
  };

  const handleCorsiClick = (e) => {
    e.preventDefault();
    
    // Chiudi il menu mobile se è aperto
    const navbarCollapse = document.querySelector(".navbar-collapse");
    if (navbarCollapse?.classList.contains("show")) {
      navbarCollapse.classList.remove("show");
    }
    
    // Reindirizza immediatamente al link esterno
    window.location.href = "https://gorgeous-klepon-89f01b.netlify.app/";
  };

  return (
    <>
      <Helmet>
        <title>{t("navbar.brand", "Andromeda Programmazione")}</title>
      </Helmet>

      <nav
        className={`navbar navbar-expand-lg fixed-top custom-navbar shadow-sm ${
          scrolled ? "navbar-scrolled" : ""
        }`}
      >
        <div className="container">
          <RouterLink
            to="/"
            className="navbar-brand fw-bold text-light"
            onClick={handleGoHome}
          >
            <span className="brand-glow">
              {t("navbar.brandShort", "Andromeda")}
            </span>{" "}
            {t("navbar.brandFull", "Programmazione")}
          </RouterLink>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
            <ul className="navbar-nav">

              {/* HOME */}
              <li className="nav-item">
                <RouterLink
                  to="/"
                  className="nav-link text-light"
                  onClick={handleGoHome}
                >
                  {t("navbar.home")}
                </RouterLink>
              </li>

              {/* SERVIZI */}
              <li className="nav-item">
                <button
                  className="nav-link btn btn-link text-light"
                  onClick={() => handleScrollTo("servizi")}
                >
                  {t("navbar.servizi")}
                </button>
              </li>

              {/* ✅ CORSI */}
              <li className="nav-item">
                <button
                  className="nav-link btn btn-link text-light"
                  onClick={handleCorsiClick}
                >
                  {t("navbar.corsi", "Corsi")}
                </button>
              </li>

              {/* CHI SIAMO */}
              <li className="nav-item">
                <RouterLink to="/chi-siamo" className="nav-link text-light">
                  {t("navbar.chiSiamo")}
                </RouterLink>
              </li>

              {/* CONSULENZA */}
              <li className="nav-item">
                <RouterLink to="/consulenza" className="nav-link text-light">
                  {t("navbar.consulenza")}
                </RouterLink>
              </li>

              {/* CONTATTI */}
              <li className="nav-item">
                <button
                  className="nav-link btn btn-link text-light"
                  onClick={() => handleScrollTo("contatti")}
                >
                  {t("navbar.contatti")}
                </button>
              </li>

              {/* LINGUE */}
              <li className="nav-item dropdown">
                <button
                  className="nav-link dropdown-toggle text-light btn btn-link"
                  data-bs-toggle="dropdown"
                >
                  🌐 {t("navbar.lingua")}
                </button>

                <ul className="dropdown-menu dropdown-menu-end">
                  <li><button className="dropdown-item" onClick={() => changeLanguage("it")}>🇮🇹 Italiano</button></li>
                  <li><button className="dropdown-item" onClick={() => changeLanguage("en")}>🇬🇧 English</button></li>
                  <li><button className="dropdown-item" onClick={() => changeLanguage("fr")}>🇫🇷 Français</button></li>
                  <li><button className="dropdown-item" onClick={() => changeLanguage("es")}>🇪🇸 Español</button></li>
                  <li><button className="dropdown-item" onClick={() => changeLanguage("de")}>🇩🇪 Deutsch</button></li>
                </ul>
              </li>

            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
